var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"tract-number"},_vm._l((_vm.tracts),function(ref,i){
var position = ref.position;
var index = ref.index;
return _c('GlobeObject',{key:i,staticClass:"number",attrs:{"position":position}},[_vm._v(_vm._s(index))])}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }